import { widgetMixin } from './widgetMixin'

export const longScopeMixin = function (autoReload = false) {
  return {
    data() {
      return {
        widgetScopes: {
          today: {
            description: 'Today',
            info: 'Statistics for today'
          },
          week: {
            description: 'Past 7 days',
            info: 'Statistics for the past 7 days'
          },
          month: {
            description: 'Past 30 days',
            info: 'Statistics for the past 30 days'
          },
          years: {
            description: 'Past 365 days',
            info: 'Statistics for the past 365 days'
          }
        },
        scopes: {
          days: {
            description: 'Days',
            info: 'Statistics for the past 7 days'
          },
          weeks: {
            description: 'Weeks',
            info: 'Statistics for the past 7 weeks'
          },
          months: {
            description: 'Months',
            info: 'Statistics for the past 7 months'
          },
          years: {
            description: 'Years',
            info: 'Statistics for the past 7 years'
          }
        },
        scopeForm: {
          scope: 'days'
        },
        widgetScopeForm: {
          scope: 'today'
        }
      }
    },
    computed: {
      selectedScope() {
        if (this.scopeForm.scope) {
          return this.scopes[this.scopeForm.scope]
        }
        return {}
      },
      selectedWidgetScope() {
        if (this.widgetScopeForm.scope) {
          return this.widgetScopes[this.widgetScopeForm.scope]
        }
        return {}
      }
    },
    methods: {
      doSelectScope(scope, reload = true) {
        if (this.scopes[scope]) {
          this.scopeForm.scope = scope
          if (reload) {
            this.doReload()
          }
        }
      },
      doSelectWidgetScope(scope, reload = true) {
        if (this.widgetScopes[scope]) {
          this.widgetScopeForm.scope = scope
          if (reload) {
            this.doReload()
          }
        }
      }
    },
    mixins: [
      widgetMixin(autoReload)
    ]
  }
}
